import { useAktualizacja } from '../dane/aktualizacja.js'
import './aktualizacja.css'

/**
 * Informacja o nowej wersji i ekran jej wdrażania.
 *
 * Pasek nie zasłania treści i nie przerywa pracy — użytkownik decyduje, kiedy
 * przełączyć. Ekran wdrażania pokazuje się tylko na te kilkaset milisekund,
 * których potrzebuje przejęcie sterowania, żeby przeładowanie nie wyglądało
 * jak przypadkowe mrugnięcie aplikacji.
 */
export function Aktualizacja() {
  const { stan, zastosuj } = useAktualizacja()

  if (stan === 'brak') return null

  if (stan === 'wdrazanie') {
    return (
      <div className="wdrazanie" role="status" aria-live="assertive">
        <div className="wdrazanie__znak">
          <span className="wdrazanie__pierscien" />
          <span className="wdrazanie__rdzen" />
        </div>
        <p className="wdrazanie__tytul">Wdrażam nową wersję</p>
        <p className="wdrazanie__opis">To potrwa chwilę</p>
      </div>
    )
  }

  return (
    <div className="aktualizacja" role="status" aria-live="polite">
      <span className="aktualizacja__kropka" aria-hidden="true" />
      <span className="aktualizacja__tekst">
        <strong>Nowa wersja jest gotowa</strong>
        <span>Odśwież, żeby z niej skorzystać</span>
      </span>
      <button type="button" className="aktualizacja__akcja" onClick={zastosuj}>
        Odśwież
      </button>
    </div>
  )
}
